import Phaser from "phaser"
import { GrassComponents, BunnyComponent, GoldBunnyComponent, OtterComponent } from './constants'
import { generateRandomNumber, randomWithProbabilities } from "../../utils/helpers";
export default class Game extends Phaser.Scene {

    targetStatus = [];

    preload() {

        this.load.audio('bg-sound', require('../../assets/sounds/BGSound.mp3'));
        this.load.audio('rustlingGrass01', require('../../assets/sounds/rustlingGrass01.mp3'));
        this.load.audio('rustlingGrass02', require('../../assets/sounds/rustlingGrass02.mp3'));
        this.load.audio('1Point', require('../../assets/sounds/1Point.mp3'));
        this.load.audio('3points', require('../../assets/sounds/3points.mp3'));
        this.load.audio('badHit', require('../../assets/sounds/badHit.mp3'));
        this.load.audio('jump', require('../../assets/sounds/jump.mp3'));



        this.load.image("background", require('./assets/v3/Background.png'));
        this.load.image("grass01", require('./assets/v3/grass_04.webp'));
        this.load.image("grass02", require('./assets/v3/grass_03.webp'));
        this.load.image("grass03", require('./assets/v3/grass_01.webp'));
        this.load.image("grass04", require('./assets/v3/grass_02.webp'));
        this.load.image("grass05", require('./assets/v3/grass_01.webp'));


        this.load.image("bunny01", require('./assets/v2/bunny_01.webp'));
        this.load.image("bunny02", require('./assets/v2/bunny_02.webp'));
        this.load.image("goldbunny", require('./assets/v2/gold_bunny.webp'));
        this.load.image("otter", require('./assets/v2/otter.webp'));

        this.load.image("leaderboard-backBtn-border", require('../../assets/back-button.png'));

    }



    create() {

        this.add.image(0, 0, "background").setOrigin(0, 0);

        this.initialTime = 60;
        this.playerScore = 0;

        this.gameConfig = {
            duration: {
                min: 800,
                max: 800
            },
            hold: {
                min: 100,
                max: 800
            },
            delay: {
                min: 1000,
                max: 13000
            }
        }

        this.canvasWidth = this.game.config.width;
        this.canvasHeight = this.game.config.height;

        this.initSound();

        // this.add.rectangle(0, 0, 1080, 1920, 0xE1D5BE).setOrigin(0, 0);
        // this.add.rectangle(0, 0, 1080, 161, 0xFFFFFF).setOrigin(0, 0);
        // this.add.image(-139, 1628, "grass06").setOrigin(0, 0);

        GrassComponents.forEach((grass, index) => {
            const grassImage = this.add.image(
                grass.pos_x,
                grass.pos_y,
                grass.asset_name
            ).setOrigin(0, 0);
            grassImage.depth = grass.depth;

            this.addNPC(grassImage, index);
        });

        this.timedEvent = this.time.addEvent({ delay: 1000, callback: this.onTimerEvent, callbackScope: this, loop: true });
        this.timeText = this.add.text(920, 30, this.initialTime, { font: '800 80px Rockridge', color: '#F05B45' });
        this.playerScoreText = this.add.text(280, 30,  this.playerScore, {font: '800 80px Rockridge'  , color: '#F05B45' });
        this.timeText.setFixedSize(150,80);
        this.playerScoreText.setFixedSize(150,80);
        
        // this.playerScoreText.setStyle({ fontWeight: 'bold' });
        this.add.text(700, 30, "Time:", { fontFamily: 'Rockridge', fontSize: 80, color: '#F05B45' });
        this.add.text(30, 30, "Score:", { fontFamily: 'Rockridge', fontSize: 80, color: '#F05B45' });
        

        this.backBtn = this.add.image(100, 1800, "leaderboard-backBtn-border").setScale(0.2);
            this.backBtn.setInteractive();
            this.backBtn.on('pointerdown', (pointer) => {
                this.bgSound.stop();
                this.scene.start('Introduction');
            });
    }

    initSound() {
        this.bgSound = this.sound.add('bg-sound', { volume: 0.3, loop: true });
        this.rustlingGrass01 = this.sound.add('rustlingGrass01', { volume: 0.7, loop: false });
        this.rustlingGrass02 = this.sound.add('rustlingGrass02', { volume: 0.7, loop: false });
        this.onePoint = this.sound.add('1Point', { volume: 0.7, loop: false });
        this.ThreePoint = this.sound.add('3points', { volume: 0.7, loop: false });
        this.badHit = this.sound.add('badHit', { volume: 0.7, loop: false });
        this.jump = this.sound.add('jump', { volume: 0.7, loop: false });

        this.soundConfig();

        this.bgSound.play();
    }

    onTimerEvent() {

        if (this.initialTime <= 0) {
            this.bgSound.stop();
            this.scene.start('GameOver', { s: this.playerScore });
        }

        this.timeText.setText( this.initialTime);
        this.timeText.setVisible(true)
        if (this.initialTime > 0) {
            this.initialTime -= 1;
        }

        if (this.initialTime <= 50) {
            this.gameConfig = {
                duration: {
                    min: 800,
                    max: 800
                },
                hold: {
                    min: 100,
                    max: 800
                },
                delay: {
                    min: 1000,
                    max: 13000
                }
            }
        }

        if (this.initialTime <= 40) {
            this.gameConfig = {
                duration: {
                    min: 600,
                    max: 600
                },
                hold: {
                    min: 100,
                    max: 600
                },
                delay: {
                    min: 1000,
                    max: 11000
                }
            }
        }

        if (this.initialTime <= 30) {
            this.gameConfig = {
                duration: {
                    min: 100,
                    max: 500
                },
                hold: {
                    min: 100,
                    max: 500
                },
                delay: {
                    min: 1000,
                    max: 10000
                }
            }
        }

        if (this.initialTime <= 20) {
            this.gameConfig = {
                duration: {
                    min: 100,
                    max: 300
                },
                hold: {
                    min: 100,
                    max: 400
                },
                delay: {
                    min: 1000,
                    max: 10000
                }
            }
        }

    }

    addNPC(grass, index) {

        this.rustlingGrass02.play();

        const componentList = { 10: GoldBunnyComponent, 35: OtterComponent, 100: BunnyComponent };
        const selectedNPC = randomWithProbabilities(componentList);
        const npcComponent = selectedNPC[index];
        const shape = this.createMask(grass, npcComponent.maskHeight, false);
        const mask = shape.createGeometryMask();
        mask.invertAlpha = true
        const x = generateRandomNumber(npcComponent.PeekPos.min_x, npcComponent.PeekPos.max_x);
        const selectedAssets = npcComponent.asset_name[generateRandomNumber(0, npcComponent.asset_name.length)];
        const npcImage = this.add.image(x, (grass.y + grass.height), selectedAssets).setOrigin(0, 0);
        npcImage.depth = npcComponent.depth;
        npcImage.setMask(mask);


        this.addNPCTweens(
            npcImage,
            x,
            npcComponent.PeekPos.y,
            generateRandomNumber(this.gameConfig.duration.min, this.gameConfig.duration.max),
            generateRandomNumber(this.gameConfig.hold.min, this.gameConfig.hold.max),
            generateRandomNumber(this.gameConfig.delay.min, this.gameConfig.delay.max),
            () => {
                this.jump.play();
            },
            (timeline) => { // on start interactive
                npcImage.setInteractive();
                
                npcImage.on('pointerdown', (pointer) => {
                    if(!this.targetStatus[index]){
                        npcImage.setInteractive(false);
                        this.targetStatus[index] = true;
                        timeline.destroy();
                        this.onNPCSmashed(npcComponent);
    
                        let timeline2 = this.tweens.createTimeline();
                        // Add a tween that increases the size of 'obj' to 1.5% to the timeline
                        timeline2.add({
                            targets: npcImage,
                            scale: 1.1,
                            duration: 500,  // Tween duration in milliseconds
                            ease: 'Linear',
                        });
                        
                        // Add a tween that fades out 'obj' to the timeline
                        timeline2.add({
                            targets: npcImage,
                            alpha: 0,
                            duration: 1000,  // Tween duration in milliseconds
                            ease: 'Linear',
                        });
                        
                        timeline2.on('complete', ()=> {
                            npcImage.destroy();
                            this.targetStatus[index] = false;
                            mask.destroy();
                            shape.destroy();
                            
                            this.addNPC(grass, index);
                          });
    
                        timeline2.play();
                    }
                    
                });
            },
            (progress) => {
                // on stop interactive
                if (progress > 50) {
                    npcImage.setInteractive(false);
                }
            },
            () => {
                npcImage.destroy();
                mask.destroy();
                shape.destroy();
                this.addNPC(grass, index);
            }
        );
    }

    onNPCSmashed(target) {

        if (target.points == 1) {
            this.onePoint.play();
        } else if (target.points == 3) {
            this.ThreePoint.play();
        } else {
            this.badHit.play();
        }

        this.playerScore += target.points;

        if (this.playerScore < 0) {
            this.playerScore = 0;
        }

        this.playerScoreText.setText(this.playerScore);
    }

    addNPCTweens(npcImage, x, y, duration, hold, delay, onStart, onHold, onUpdate, onComplete) {
        let timeline = this.tweens.createTimeline();
        const initialY = npcImage.y;
        let isHold = false;
        timeline.add({
            targets: npcImage,
            x: x,
            y: y,
            ease: 'Power4',
            duration: duration,
            delay: delay,
            onStart: onStart,
            onUpdate: (tween, target) => {
                if (((y / target.y) * 100) > 75 && !isHold) {
                    isHold = true;
                    onHold(timeline,npcImage);
                }
            }
        });

        timeline.add({
            targets: npcImage,
            y: initialY,
            ease: 'Power4',
            duration: duration,
            delay: hold,
            onComplete: () => {
                onComplete();
            },
            onUpdate: (tween, target) => {
                onUpdate((target.y / initialY) * 100)
            }
        });

        timeline.play();
    }

    createMask(grass, height, show) {

        if (show) {
            const rect = this.add.rectangle(grass.x, grass.y + grass.height - 2, grass.width, height, 0x9b9b9b).setOrigin(0, 0);
            rect.alpha = 0.5;
        }

        const shape = this.make.graphics();
        shape.fillStyle(0xffffff);
        shape.beginPath();
        shape.fillRect(
            grass.x,
            grass.y + grass.height - 2,
            grass.width,
            height
        );
        return shape;
    }

    soundConfig(){
        this.bgSound.mute = !this.game.config.soundSetting;
        this.rustlingGrass01.mute = !this.game.config.soundSetting;
        this.rustlingGrass02.mute = !this.game.config.soundSetting;
        this.onePoint.mute = !this.game.config.soundSetting;
        this.ThreePoint.mute = !this.game.config.soundSetting;
        this.badHit.mute = !this.game.config.soundSetting;
        this.jump.mute = !this.game.config.soundSetting;
    }

    update() {

    }

}